import toast from 'react-hot-toast'

export { toast }

export function confirmDialog ({ title, text, onConfirm, confirmLabel = 'Conferma', cancelLabel = 'Annulla' }) {
  toast((t) => (
    <div style={{ display: 'flex', flexDirection: 'column', gap: 12 }}>
      <strong style={{ fontSize: '1rem' }}>{title}</strong>
      {text && <span style={{ fontSize: '0.9rem', color: 'var(--sf-text-muted)' }}>{text}</span>}
      <div style={{ display: 'flex', gap: 8, justifyContent: 'flex-end' }}>
        <button
          onClick={() => toast.dismiss(t.id)}
          style={{
            padding: '6px 14px',
            borderRadius: 'var(--sf-radius-sm)',
            border: '1px solid var(--sf-border)',
            background: 'var(--sf-surface)',
            cursor: 'pointer',
            fontSize: '0.85rem',
            fontWeight: 600
          }}
        >
          {cancelLabel}
        </button>
        <button
          onClick={() => { toast.dismiss(t.id); onConfirm() }}
          style={{
            padding: '6px 14px',
            borderRadius: 'var(--sf-radius-sm)',
            border: 'none',
            background: 'var(--sf-red-500)',
            color: 'white',
            cursor: 'pointer',
            fontSize: '0.85rem',
            fontWeight: 600
          }}
        >
          {confirmLabel}
        </button>
      </div>
    </div>
  ), { duration: 10000, style: { maxWidth: 400 } })
}
